import { createReducer, createAction  } from '@reduxjs/toolkit';
import { BranchListAction, CRMData, CRMPostData, CompanyListAction, CustomerCreationAction,
   OpprtunityBySlpCode,
   UpdateCustomerDataAction, outGoingPayment, outGoingPaymentAction, 
   resetCrmData, resetCustomerDetails, resetItemGroup, resetItems, setItemGroup, setItems } from './actions';
import { json } from 'react-router-dom';

const initialState = {
  opprData:null,
    itemGroup: JSON.parse(localStorage.getItem('ItemGroup')) || null,
    items: JSON.parse(localStorage.getItem('Items')) || null,
    outPayment: JSON.parse(localStorage.getItem('OutGoingPayment')) || null,
    CompanyList: JSON.parse(localStorage.getItem('CompanyList')) || null,
    BranchList: JSON.parse(localStorage.getItem('BranchList')) || null,
    CRMPostData: JSON.parse(sessionStorage.getItem('CRMPostData')) || null,
    customerData: JSON.parse(localStorage.getItem('customerData')) || {
      CustomerDetails: {
          customerName: '',
          ForeignName: '',
          phoneNumber: '',
          address: ''
      }
  },
};

export const itemReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setItemGroup, (state, action) => {
      state.itemGroup = action.payload;
      localStorage.setItem('ItemGroup', JSON.stringify(action.payload));
    })
    .addCase(setItems, (state, action) => {
      state.items = action.payload;
      localStorage.setItem('Items', JSON.stringify(action.payload));
    })
    .addCase(resetItemGroup, (state) => {
      state.itemGroup = null;
      localStorage.removeItem('ItemGroup');
    })
    .addCase(resetItems, (state) => {
      state.items = null;
      localStorage.removeItem('Items');
    })
    .addCase(outGoingPaymentAction, (state, action) => {
      state.outPayment =action.payload;
      localStorage.setItem('OutGoingPayment', JSON.stringify(action.payload))
    })
    .addCase(CompanyListAction, (state, action) => {
      state.CompanyList =action.payload;
      localStorage.setItem('CompanyList', JSON.stringify(action.payload))
    })
    .addCase(BranchListAction, (state, action) => {
      state.BranchList =action.payload;
      localStorage.setItem('BranchList', JSON.stringify(action.payload))
    })
    .addCase(UpdateCustomerDataAction, (state, action) => {
      state.customerData.CustomerDetails = {
          ...state.customerData.CustomerDetails,
          ...action.payload.CustomerDetails
      };
      localStorage.setItem('customerData', JSON.stringify(state.customerData));
  })
  .addCase(CustomerCreationAction, (state, action) => {
    state.customerData = action.payload;
    localStorage.setItem('customerData', JSON.stringify(action.payload));
  })
  .addCase(CRMData, (state, action) => {
    state.CRMData = action.payload;
    localStorage.setItem('CRMData', JSON.stringify(action.payload));
  })
  .addCase(OpprtunityBySlpCode, (state, action) => {
    state.opprData = action.payload;
    // localStorage.setItem('CRMData', JSON.stringify(action.payload));
  })
  
  .addCase(CRMPostData, (state, action) => {
    state.CRMPostData = action.payload;
    sessionStorage.setItem('CRMPostData', JSON.stringify(action.payload));

  })
  
  
  .addCase(resetCustomerDetails, (state) => {
      state.customerData.CustomerDetails = {
        customerName:'' ,
        ForeignName: '',
        GroupName:'',
        GroupCode:'',
        salesPerson:'',
        SlpCode:'',
        mobileNumber:'',
        phone:'',
        Email:'',
        Address_Block:'',
        Address_Street: '',
        Address_City:'',
        Address_State:'',
        stateName:'',
        Address_Id: 'Default',
        Address_Country: 'India',
        Address_ZipCode: '',
        ContactEmployeeName: '',
        ContactEmployeePosition: '',
        ContactEmployeePhone: '',
        ContactEmployeeMobileNumber: '',
        ContactEmployeeEmail: '',
        ContactEmployeeAddress: '',
        Address_GstNumber:'' ,
        Tax_PanNo: '',
        Bank_BeneficiaryName: '',
        Bank_BeneficiaryAccountNumber: '',
        Bank_Name: '',
        Bank_Branch:'',
        Bank_IFSCCode:'',
        PaymentTerms:'',
        CreditLimit:'',
        bankName:'',
        PaymentName:'',
      };
      localStorage.removeItem('customerData');
  })
  .addCase(resetCrmData, (state) => {
    state.CRMPostData = {
      existingcust: "",
      CustomerName: '',
      WalkInType: '',
      PhoneNo: '',
      Reference :'',
      LeadLevel : '',
      AssignExecutive :'',
      customerCategory: '',
      Segment:[],
      ReqType:"",
      CustomerProfile:'',
      SiteType:'',
      CurrentWorkStatus:'',
      ExpectedComplationOfWork:'',
      ItemsChecked:[],
      EstimatedValue:'',
      RequrimentType:'',
      SiteVist:'', 
      Address:''
    };
    localStorage.removeItem('CRMPostData');
});
});